import Ajuda from './Ajuda';
import Arquivo from './Arquivo';
import Assinatura from './Assinatura';
import Avaliacao from './Avaliacao';
import Botao from './Botao';
import CaixaDeSelecao from './CaixaDeSelecao';
import CaixaDeTexto from './CaixaDeTexto';
import Campo from './Campo';
import CampoOculto from './CampoOculto';
import Contexto from './Contexto';
import Erro from './Erro';
import Form from './Form';
import Grupo from './Grupo';
import Radio from './Radio';
import Rotulo from './Rotulo';
import Selecao from './Selecao';

export {
  Ajuda,
  Arquivo,
  Assinatura,
  Avaliacao,
  Botao,
  CaixaDeSelecao,
  CaixaDeTexto,
  CampoOculto,
  Contexto,
  Campo,
  Erro,
  Grupo,
  Radio,
  Rotulo,
  Selecao,
};

export default Form;
